module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp123_3009.637e7adf.png";